import type { ReactNode } from "react";

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
}

const EmptyState = ({ icon, title, description }: EmptyStateProps) => (
  <div className="p-4 bg-white rounded-lg">
    <div className="text-center py-12">
      <div className="text-6xl text-gray-300 mb-4 flex justify-center">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-gray-700 mb-2">{title}</h3>
      <p className="text-gray-500">{description}</p>
    </div>
  </div>
);

export default EmptyState;
